import React from 'react';
import { Link } from 'gatsby';

import './style.scss';

const CheckbookLink = props => {
  const { to, className, value, style } = props;

  if (!to) {
    return null;
  }

  if (!to.startsWith('http')) {
    return (
      <Link to={to} className={className} style={style}>
        {value}
      </Link>
    );
  } else {
    return (
      <a href={to} className={className} style={style}>
        {value}
      </a>
    );
  }
};

export default CheckbookLink;
